module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAPUExURUdwTDx2/z52/yp+/z52/2/nctEAAAAEdFJOUwCJ5walK4aLAAAAQklEQVRYw+3UMQ0AIAxFQTyABAwgAYJ/TWxN2Arz3f6TdnmlAJfRd8KqMWg7Zcag5wbrf/B80vPTAOqt3gDqrd4QDmZuut/ZKfFsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_menu_iconHover.png
// module id = 8XRj
// module chunks = 34